import React from 'react';
import Skills from './Skills.js';
import Tilt from 'react-parallax-tilt';
import Lottie from "lottie-react"
import Coder from '../LottieFiles/coder.json';

const About = () => {
  return (
    <>
      <div className='AboutPage'>
        <div className='AboutText'>
          <h1 className='AboutTextHeading' >Get to <b>know</b> me!</h1>
          <p>
            Hi, my name is <b>Pradeepika Nori</b> and I am from Hyderabad, Telangana.
            I'm currently a <b>pre-final year B.Tech student</b> pursuing <b>Computer Science and Engineering</b> at <b>Indian Institute of Technology, Jodhpur.</b> <br/><br/>
            With hands-on experience across <b>industry-level projects</b>, I build secure, scalable, and user-focused solutions. My areas of interest are encryption systems, machine learning, AI-driven applications, and full-stack development, always aiming for <b>clean architecture</b> and <b>impactful results</b>.

            {/* I'm currently working on projects that involve transforming data into easily-digestible, .<br/><br/> */}
            <br/><br/>
            I am <b>open</b> to new collaborations and opportunities to grow more and contribute as a developer. Let's connect—links are in the footer!<br/>
          </p>
        </div>

        <div>
          <Tilt>
              <Lottie 
              className="illustration" 
              animationData={Coder} 
              loop={true} 
            />
          </Tilt>
        </div>

      </div>
      
      <h1 className='SkillsHeading'>Professional <b>Skillset</b></h1>
      <div className='skills'>
        
        <Skills skill='C++' />
        <Skills skill='Javascript' />
        <Skills skill='React' />
        <Skills skill='Node' />
        <Skills skill='MySQL' />
        <Skills skill='Git' />
        <Skills skill='Github' />
        <Skills skill='Postman' />
        <Skills skill='Figma' />
        <Skills skill='Npm' />
        <Skills skill='Bootstrap'/>
      </div>
    </>
  )
}

export default About